// extracted by mini-css-extract-plugin
export default {"announcement":"Announcement_announcement__XRlKx","date":"Announcement_date__iaQ4M","title":"Announcement_title__zxCIM","desc":"Announcement_desc__DPSf9"};